<template>
  <InsightCard
    title="Top Spending Campaigns"
    column1="Campaign Name"
    column2="Share"
    column3="Spend"
    apiUrl="/google-ads-insights/campaign-level-spends"
    :displayIndex="index"
    :formatter="formatNumber"
    :change="3"
    srcName="gads"
  />
</template>

<script setup>
import { formatNumber } from '@/utils/helperFunctions';
import InsightCard from '@/components/InsightCard.vue';

const index = [0, 1];
</script>
